<template>
  <router-view />
</template>

<script>
export default {
  mounted() {
    this.updateThemeClass(this.$store.state.userLogin)
  },
  watch: {
    '$store.state.userLogin'(newValue) {
      this.updateThemeClass(newValue)
    }
  },
  methods: {
    updateThemeClass(isLightMode) {
      if (isLightMode) {
        document.body.classList.add('active-light-mode')
      } else {
        document.body.classList.remove('active-light-mode')
      }
    }
  }
}
</script>
